import { HttpClient } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Constants } from 'avn/modules/services/constants';
import { Observable, catchError, throwError } from 'rxjs';

interface ISitemapCategoryService {
  name: string;
}

interface ISitemapCategory {
  name: string;
  services: ISitemapCategoryService[];
}

interface ISitemapCategoriesResponse {
  data: ISitemapCategory[];
}

@Injectable({
  providedIn: 'root'
})
export class SitemapCustomService {
  private readonly errorHandler: ErrorHandler;

  public constructor(
    private readonly httpClient: HttpClient,
    private readonly injector: Injector
  ) {
    this.errorHandler = this.injector.get(ErrorHandler);
  }

  public getCategoryServices(): Observable<ISitemapCategoriesResponse> {
    const endPoint = '/categories-service/';
    return this.httpClient
      .get<ISitemapCategoriesResponse>(Constants.BASE_URL + endPoint)
      .pipe(catchError(this.handleError.bind(this)));
  }

  private handleError(error: unknown): Observable<never> {
    // Call the global error handler
    this.errorHandler.handleError(error);

    // Re-throw the error so it can be caught by the component's subscribe error handler
    return throwError(() => error);
  }
}
